import React from 'react';
import './TCOTableComponent.scss';
import { tcoFormattedPrice } from 'utils/defaultsAndConstants/tcoConstants';

export interface TableRow {
  label: string;
  values: Record<string, number>;
}

interface Props {
  rows: TableRow[];
  totalLabel?: string;
}

const columns = [
  { column: 'Edge', accessor: 'edge' },
  { column: 'Switch', accessor: 'switch' },
  { column: 'AP', accessor: 'ap' },
  { column: 'Camera', accessor: 'camera' },
  { column: 'Total', accessor: 'total' },
];

const Table: React.FC<Props> = ({ rows }) => {
  const calculateTotal = () => {
    return rows.reduce((total, row) => total + row.values.total, 0);
  };

  return (
    <table className="custom-table">
      <thead>
        <tr>
          <th></th>
          {columns.map((col) => (
            <th key={col.accessor}>{col.column}</th>
          ))}
        </tr>
      </thead>

      <tbody>
        {rows.map((row) => (
          <tr key={row.label}>
            <td className="row-label">{row.label}</td>
            {columns.map((col) => (
              <td key={col.accessor}>
                ${tcoFormattedPrice(row.values[col.accessor])}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr>
          <td className="total-label" colSpan={columns.length}>
            Monthly Operational Costs
          </td>
          <td colSpan={columns.length}>
            ${tcoFormattedPrice(calculateTotal())}
          </td>
        </tr>
      </tfoot>
    </table>
  );
};

export default Table;
